import { Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {DocumentMetadataService} from "../../../api/service/documentMetadata.service";
import {DocumentService} from "../../../api/service/document.service";
import {DocumentMetadata} from "../../../api/model/documentMetadata";
import {DocumentUrl} from "../../../api/model/documentUrl";
import { SharedService } from '../../service/shared.service';
import { NxMessageToastService } from '@aposin/ng-aquila/message';
import { InfoDialogService } from '../../../app/interceptors/modal/info-dialog.service';
import { TabsComponent } from '../../tabs/tabs.component';

import {FilterDocumentMetadata} from "../../../api/model/filterDocumentMetadata";

@Component({
	selector: 'app-details',
	templateUrl: './details.component.html',
	styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
	readonly toastUploadSuccessText: string = 'Änderungen wurden erfolgreich aktualisiert!';
	readonly toastLockedText: string = 'Anzeige Indexwerte: Es können keine Daten geändert werden.';
	readonly toastOpenedText: string = 'Änderung Indexwerte: Hier können Daten geändert werden.';
	readonly emailText: string = "mailto:?Subject=Dokument Verknüpfungen&body=Bitte nutzen Sie die nachstehende Verknüpfung, um das Dokument in der eAkte+ zu öffnen: %0D";

	tabTitle: string = 'Dokument Details';
	filter: FilterDocumentMetadata = {};
	loader = false;
	update = false;
	dataLoaded = false;
	showCheckbox = true;

	documentMetadata: DocumentMetadata = {};
	myMap: Map<string, string> = new Map();
	linkId?: string;

	constructor(
    private readonly messageToastService: NxMessageToastService,
    private readonly documentMetadataService: DocumentMetadataService,
    private readonly documentService: DocumentService,
    private readonly oauthService: OAuthService,
    private readonly sharedService: SharedService,
	private infoDialogService: InfoDialogService,
	private tabsComponent: TabsComponent
	) {}

	ngOnInit(): void {
	  this.documentService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
	  this.documentMetadataService.configuration.apiKeys = {Authorization: `Bearer ${this.oauthService.getAccessToken()}` };
		if (!!this.linkId) {
		  const linkIdValue: string = String(this.linkId).split('&')[0];
		  this.loader = true;
		  localStorage.removeItem('details');
	      this.documentMetadataService.documentMetadataGet(linkIdValue).subscribe((documentMetadata: DocumentMetadata) => {
				this.documentMetadata = documentMetadata;				
				this.dataLoaded = true;
				this.loader = false;				
				if (String(this.linkId).split('&').length > 1 && String(this.linkId).split('&')[1] === 'openDocument'){
					this.openDocument();
				}
				if (String(this.linkId).split('&').length > 1 && String(this.linkId).split('&')[1] === 'updateDocument'){
					this.setUpdateFromLink();
				}
			}, error => {
				this.loader = false;
					throw error;
				}
			);			
		} else {
		  this.setTabTitleOnTabs();
		  this.dataLoaded = true;
		}

	}
	
	setTabTitleOnTabs() {
		//Vorgang ID
		const coverProcessIdFilter =  !!this.filter?.filterMetadata?.coverProcessId && String(this.filter?.filterMetadata?.coverProcessIdFilterOperation) === 'EQUAL';
		//Personennummer DN
		const policyHolderIdIdFilter =  !!this.filter?.filterMetadata?.policyHolderId && String(this.filter?.filterMetadata?.policyHolderIdFilterOperation) === 'EQUAL';
		//Personennummer AK
		const foreignCustomerIdFilter =  !!this.filter?.filterMetadata?.foreignCustomerId && String(this.filter?.filterMetadata?.foreignCustomerIdFilterOperation) === 'EQUAL';
		//APG Vertrag 
		const contractNumberFilter =  !!this.filter?.filterMetadata?.contractNumber && String(this.filter?.filterMetadata?.contractNumberFilterOperation) === 'EQUAL';
			
		const trueCount = [coverProcessIdFilter, policyHolderIdIdFilter, foreignCustomerIdFilter, contractNumberFilter].filter(Boolean).length;
		console.log(`this.filter ${JSON.stringify(this.filter)}`);
		console.log(`trueCount ${trueCount} coverProcessIdFilter ${coverProcessIdFilter} policyHolderIdIdFilter ${policyHolderIdIdFilter} foreignCustomerIdFilter ${foreignCustomerIdFilter} contractNumberFilter ${contractNumberFilter}`);
		if (coverProcessIdFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'ECA Index Vg.ID ' + this.documentMetadata?.coverProcessId!.toString()!);	
		}else if (policyHolderIdIdFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'ECA Index Pers.Nr.DN ' +this.documentMetadata?.policyHolderId!.toString()!);	
		}else if (foreignCustomerIdFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'ECA Index Pers.Nr.AK ' + this.documentMetadata?.foreignCustomerId!.toString()!);	
		}else if (contractNumberFilter && trueCount === 1){
			this.tabsComponent.changeTabTitle(this.tabTitle, 'ECA Index APG Vertrag ' + this.documentMetadata?.contractNumber!.toString()!);	
		}else {
			if (this.update){				
				this.tabsComponent.changeTabTitle(this.tabTitle, this.tabTitle.replace('anzeigen', 'ändern'));	
				this.tabTitle = this.tabTitle.replace('anzeigen', 'ändern');
			} else {
				this.tabsComponent.changeTabTitle(this.tabTitle, this.tabTitle.replace('ändern', 'anzeigen'));	
				this.tabTitle = this.tabTitle.replace('ändern', 'anzeigen');
			}
		}			
	}

	callBackend() {
		this.loader = true;
		this.documentMetadataService.documentmetadataPut(this.documentMetadata!.dui, this.documentMetadata).subscribe((data: any) => {
  		this.update = false;
		this.setTabTitleOnTabs();
  		this.toastUploadSuccess();
  		this.loader = false;
		}, error => {
		      this.loader = false;
			    throw error;
			  }
		);
	}

	generateSearchLink() {
		let openDocumentDetailsText = window.location.href + "/document/" + this.documentMetadata!.dui + "%0D";
		window.location.href = this.emailText  + openDocumentDetailsText;
	}

	importSimilar() {
	  this.sharedService.sendMessage('importSimilar', this.documentMetadata);
	}

	openSimilarSearch() {
		this.sharedService.sendMessage('similarSearch', this.myMap);
	}

	reset() {
		this.loader = true;
		if (this.documentMetadata.version) {
			this.documentMetadataService.documentmetadataHistoryGetVersion(this.documentMetadata.dui, this.documentMetadata.version).subscribe((documentMetadata: DocumentMetadata) => {
	      this.documentMetadata = documentMetadata;
	      this.loader = false;
			}, error => {
		      this.loader = false;
			    throw error;
			  }
			);
		} else {
			this.documentMetadataService.documentmetadataHistoryGet(this.documentMetadata.dui).subscribe((documentMetadatas: DocumentMetadata[]) => {
	      this.documentMetadata = documentMetadatas[0];
	      this.loader = false;
			}, error => {
		      this.loader = false;
			    throw error;
			  }
			);
		}
	}

	openDocument() : void {	  			
	  if (String(this.documentMetadata.jadeDocumentStatus) !== 'PROCESSING_FAILED' && String(this.documentMetadata.jadeDocumentStatus) !== 'ABORTED') {
	    this.loader = true;
		this.documentService.documentGet(this.documentMetadata.dui).subscribe((documentUrl: DocumentUrl) => {
				window.open(documentUrl.presignedUrl);
				this.loader = false;
			}, error => {
		      this.loader = false;
			  let msg: string = "";
			  if ((this.hasJadeIsFileUploaded() && !this.getJadeIsFileUploaded()) ||
						String(this.documentMetadata.jadeDocumentStatus) === "FAILED_UPLOADING_TO_JADE" ||
						String(this.documentMetadata.jadeDocumentStatus) === "FAILED_UPLOADING_TO_JADE_RETRY"){
				msg = "Das Dokument kann nicht geöffnet/heruntergeladen werden, da bereits während des Uploadvorgangs technische Probleme aufgetreten sind. Bitte versuche den Upload der Datei erneut oder kontaktiere den Lade-User des Dokuments.";				
			  }
			  if (this.hasJadeDocumentFailureReasonCode()){
				msg = DetailsComponent.getJadeErrorMessage(this.getJadeDocumentFailureReasonCode());
				if (this.hasJadeDocumentFailureReasonDescription()){
					msg += ` ${this.getJadeDocumentFailureReasonDescription()}`;
				}				
			  }

			  if (msg !== ""){
				let details: string = `${JSON.stringify(this.documentMetadata.jadeDocumentInfo)} ${JSON.stringify(this.documentMetadata.jadeDocumentError)}`
				var businessError = { message: msg, details, title: "Fehlermeldung: Datei-Upload fehlgeschlagen:"};
				this.infoDialogService.openDialog(businessError);
				return;
			  }
			  throw error;
			  }
		);
		} else{
			let msg: string = "";
			  if (this.hasJadeIsFileUploaded() && !this.getJadeIsFileUploaded()){
				msg = "Das Dokument kann nicht geöffnet/heruntergeladen werden, da bereits während des Uploadvorgangs technische Probleme aufgetreten sind. Bitte versuche den Upload der Datei erneut oder kontaktiere den Lade-User des Dokuments.";				
			  }
			  if (this.hasJadeDocumentFailureReasonCode()){
				msg = DetailsComponent.getJadeErrorMessage(this.getJadeDocumentFailureReasonCode());
				if (this.hasJadeDocumentFailureReasonDescription()){
					msg += ` ${this.getJadeDocumentFailureReasonDescription()}`;
				}				
			  }

			  if (msg !== ""){
				let details: string = `${JSON.stringify(this.documentMetadata.jadeDocumentInfo)} ${JSON.stringify(this.documentMetadata.jadeDocumentError)}`
				var businessError = { message: msg, details, title: "Fehlermeldung: Datei-Upload fehlgeschlagen:"};
				this.infoDialogService.openDialog(businessError);
				
			  }		
		}
	}

	public static getJadeErrorMessage(documentFailureReasonCode: any): string {
		const errorMap: Record<string, string> = {
			"REJECTED_BY_SECURITY_MATRIX_MIME_TYPE_INVALID":
				"Der erkannte MIME-Typ der Datei ist nicht mit dem verwendeten Sicherheitsprofil kompatibel. / Der MIME Typ ist ungültig.",
			"SANITIZATION_FAILED_UNSUPPORTED_DOCUMENT":
				"Das Dokument konnte nicht hochgeladen werden, da es (oder einen Teil davon) nicht von unserem Anbieter unterstützt wird. Dies geschieht normalerweise bei sehr alten Versionen von Microsoft Word oder Excel (wie Office 95). Das Dokument muss in einer neueren Version gespeichert werden, um archiviert zu werden.",
			"SANITIZATION_FAILED_PASSWORD_PROTECTED_DOCUMENT":
				"Das Dokument konnte nicht hochgeladen werden, da es (oder einen Teil davon) passwortgeschützt ist. Das Passwort muss entfernt werden, damit das Dokument archiviert werden kann.",
			"SANITIZATION_FAILED_PROVIDER_INTERNAL_ERROR":
				"Auf der Seite unseres Sicherheitsanbieters ist ein technischer Fehler während des Sanitization Prozesses aufgetreten.",
			"SANITIZATION_FAILED":
				"Das Dokument konnte aus einem anderen Grund als vorhandener Passwortschutz oder nicht unterstütztes Dateiformat nicht hochgeladen werden. Der externe Sicherheitsanbieter konnte die Datei nicht bereinigen (sanitization). Bitte überprüfen Sie die “documentFailureReasonDescription” für weitere Details.",
			"FILE_TOO_BIG":
				"Das Dokument ist größer als 20 MB (Die maximal zulässige Größe hängt vom Sicherheitsprofilcode ab).",
			"EMPTY_FILE":
				"Die gesendete Datei ist leer (0 Bytes). Kein erneuter Versuch erforderlich.",
			"AV_TIME_OUT":
				"Zeitüberschreitung, bitte Upload erneut versuchen.",
			"AV_RISK_DETECTED":
				"Der externe Sicherheitsanbieter hat die Datei als unsicher markiert (z.B. einen Virus entdeckt), sie kann aus Sicherheitsgründen nicht hochgeladen werden.",
			"ABORTED_AV_LIMIT_REACHED":
				"Das von dem externen Anbieter (OPSWAT) erlaubte Antivirus-Kontingent wurde erreicht.",
			"DECLINED_BY_SECURITY_RULES":
				"Das Dokument wurde von der Sicherheits-API abgelehnt, was beispielsweise passiert, wenn der Dateityp im Profilcode nicht erlaubt ist.",
			"JADE_INTERNAL_ERROR":
				"Der Server hat ein unerwartetes Problem festgestellt, bitte den Upload erneut versuchen."
		};

		const defaultMessage = "Der Upload der Datei wurde abgebrochen. Eventuell könnte die Datei potenziell gefährdende Inhalte enthalten. Es könnte sich hierbei jedoch auch um eine falsch positive Erkennung handeln. Empfohlene Schritte: 1. Überprüfen Sie die Datei: Stellen Sie sicher, dass die Datei keine schädlichen oder andere potentiell gefährdende Inhalte (wie z.B. XML, Makros, Verschlüsselung etc.) enthält. 2. Kontaktieren Sie den eAkte+ Support um weitere Unterstützung zu erhalten.";
		
		
		// Handle null, undefined, or empty input safely
		if (!documentFailureReasonCode || typeof documentFailureReasonCode !== "string" || documentFailureReasonCode.trim() === "") {
			return defaultMessage;
		}

		// Normalize input (spaces, slashes → underscores)
		const normalizedCode = documentFailureReasonCode.trim().toUpperCase().replace(/[\/\s]+/g, "_");

		// Try to find a key that starts with the normalized code
		const matchedKey = Object.keys(errorMap).find(key =>
			normalizedCode.startsWith(key)
		);

		return matchedKey ? errorMap[matchedKey] : defaultMessage;
	}

	hasJadeDocumentFailureReasonCode(): boolean {
		try {
			const info = JSON.parse(this.documentMetadata?.jadeDocumentInfo || '{}');
			return info && typeof info.documentFailureReasonCode !== 'undefined' && info.documentFailureReasonCode !== null;
		} catch (error) {
			return false;
		}
	}

	getJadeDocumentFailureReasonCode(): string {
		if (this.hasJadeDocumentFailureReasonCode()) {
			const info = JSON.parse(this.documentMetadata?.jadeDocumentInfo || '{}');
			return info.documentFailureReasonCode;
		}
		return "";
	}

	hasJadeIsFileUploaded(): boolean {
		try {
			const info = JSON.parse(this.documentMetadata?.jadeDocumentInfo || '{}');
			return info && typeof info.isFileUploaded !== 'undefined' && info.isFileUploaded !== null;
		} catch (error) {
			return false;
		}
	}

	getJadeIsFileUploaded(): boolean {
		if (this.hasJadeIsFileUploaded()) {
			const info = JSON.parse(this.documentMetadata?.jadeDocumentInfo || '{}');
			return info.isFileUploaded;
		}
		return true;
	}


	getJadeDocumentFailureReasonDescription(): string {
		if (this.hasJadeDocumentFailureReasonDescription()) {
			const info = JSON.parse(this.documentMetadata?.jadeDocumentInfo || '{}');
			return info.documentFailureReasonDescription;
		}
		return "";
	}

	hasJadeDocumentFailureReasonDescription(): boolean {
		try {
			const info = JSON.parse(this.documentMetadata?.jadeDocumentInfo || '{}');
			return info && typeof info.documentFailureReasonDescription !== 'undefined' && info.documentFailureReasonDescription !== null;
		} catch (error) {
			return false;
		}
	}

	toastLocked() {
		this.messageToastService.open(this.toastLockedText, {
			context: 'info',
			duration: 2000,
		});
	}

	toastOpened() {
		this.messageToastService.open(this.toastOpenedText, {
			context: 'info',
			duration: 2000,
		});
	}

	toastUploadSuccess() {
		this.messageToastService.open(this.toastUploadSuccessText, {
			context: 'success',
			duration: 5000,
		});
	}

	setUpdate() {
		this.loader = true;
		this.update = true;
		this.setTabTitleOnTabs();
		setTimeout(() => {
			this.loader = false;			
			this.toastLocked();
		}, 1000);
	}

	setUpdateFromLink() {
		this.loader = true;
		this.update = true;	
		this.setTabTitleOnTabs();
		setTimeout(() => {
			this.loader = false;					
		}, 100);
	}
}
